import { datadogRum } from '@datadog/browser-rum'

datadogRum.init({
  applicationId: 'bfcb15d0-62fa-467c-a6eb-4605cafa1010',
  clientToken: 'pub90d8dfeed71287b70e164c7d286b6225',
  site: 'datadoghq.com',
  service: 'arpeggi-app',
  env: window.ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sampleRate: 10,
  premiumSampleRate: 0,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input'
})

datadogRum.startSessionReplayRecording()

export default datadogRum
